import React from 'react';

import CookieBannerPanel from '@components/CookieBanner/shared/CookieBannerPanel';
import {
  COOKIE_BANNER_VERSION_V3,
  createNavigationLink
} from '@components/CookieBanner/shared/utils';

import styles from './cookieCategoryDetails.scss';

interface CookieCategoryDetailsProps {
  category: string;
  children: React.ReactNode;
  navigation: unknown;
  linkText: string;
}

function CookieCategoryDetails(props: CookieCategoryDetailsProps) {
  const { children, category, navigation, linkText } = props;

  return (
    <div className={styles.wrapper}>
      <p className={styles.text}>{children}</p>

      <CookieBannerPanel.Link
        version={COOKIE_BANNER_VERSION_V3}
        onClick={createNavigationLink(navigation, category)}>
        {linkText}
      </CookieBannerPanel.Link>
    </div>
  );
}

export default CookieCategoryDetails;
